import { ObjectMapper } from 'json-object-mapper';
import { Model } from 'services/models/model';
import { IModel } from 'services/models/IModel';
import { RecruitmentAdmissionCustomFieldItemOptionModel } from './recruitment-admission-custom-field-item-option.model';

/**
 * Campo de admissão digital (escopo CompanyGroup), usado no pré-cadastro.
 * Não reutiliza `RecruitmentCustomFieldItemModel` (vaga) para evolução independente do modelo.
 */
export class RecruitmentAdmissionCustomFieldItemModel
  extends Model
  implements IModel<RecruitmentAdmissionCustomFieldItemModel>
{
  public companyGroupId: string = '';
  public label: string = '';
  public arquivo: boolean = false;
  public inputType: string = '';
  public placeholder: string = '';
  public description: string = '';
  public parentItemId: string = '';
  public required: boolean = false;
  public order: number = 0;
  public parentItem?: RecruitmentAdmissionCustomFieldItemModel;
  public itemChildren?: RecruitmentAdmissionCustomFieldItemModel[] = [];
  public options?: RecruitmentAdmissionCustomFieldItemOptionModel[] = [];
  public isChild: boolean = false;
  public isUpdate: boolean = false;
  public fullLabel: string = '';

  static create(input: any): RecruitmentAdmissionCustomFieldItemModel {
    if ('parentItem' in input) {
      input.parentItem = input.parentItem
        ? RecruitmentAdmissionCustomFieldItemModel.create(input.parentItem)
        : null;
    }

    if ('itemChildren' in input) {
      input.itemChildren = input.itemChildren
        ? input.itemChildren.map(RecruitmentAdmissionCustomFieldItemModel.create)
        : [];
    }

    if ('options' in input) {
      input.options = input.options
        ? input.options.map(RecruitmentAdmissionCustomFieldItemOptionModel.create)
        : [];
    }

    return ObjectMapper.deserialize<RecruitmentAdmissionCustomFieldItemModel>(
      RecruitmentAdmissionCustomFieldItemModel,
      input
    );
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}
